<template>
    <div class="container">
        <p>
            This is an events page.
        </p>
    </div>
</template>

<script>

export default {
    name: 'PageEvents',
    props: {
        title: String
    }
}
</script>
